import trainCategories from '../train-categories'

/**
 * 函数:创建分类的树状结构
*/
let buildTrainCategoryTree = ()=>
{
  let tc = GLOBAL.trainClass;
  let rest = 
  `
  0 全部训练
  10 认知训练 0
  11 言语训练 0
  12 情绪与社会认知训练 0
  `.trim()
    .split('\n')
    .map(x=>x.trim().split(' '))
    .map(x=>({id: x[0], label: x[1], pid: x[2]||null}));
  let tree_entries = tc.concat(rest);
  let trainCats = new trainCategories.TrainCategories(tree_entries);
  return trainCats;
}

/**
 * 工具函数: 拍平游戏
 */
let canonicalizeGames = (gameData)=>
{
  let ret = [];
  for (let ver_tag in gameData)
  {
    gameData[ver_tag].forEach(x=>
    {
      x.ver_tag = ver_tag; 
      x.image = GLOBAL.cognition + x.image; 
      ret.push(x);
    });
  }
  return ret;
}

export default {
  buildTrainCategoryTree,
  canonicalizeGames,
};



// WEBPACK FOOTER //
// ./src/bz/utils/index.js